const webase = {
    model: {
        auth_token: null,
        user_id: null,
        loading: false,
        currentUser: {
            id: null,
            name: '',
            image: '',
            referral_code: '',
            email: '',
            account_type: ''
        },
        app: null,
        website: {
            id: null,
            webpages: []
        },
        views: [],
        styleGuide: null,
        apps: [],
        components: [],
        themes: [],
        fonts: [],
        icons: [],
        iconsByCategory: {},
        isCustomDomain: false,
        highlightClasses: ['border-dashed', 'border-2', 'border-gray-300'],
        componentCategoryOptions: ['Headers', 'Features', 'Navbars', 'Register / Sign In', 'Logo Clouds', 'Cards',
            'Testimonials', 'Pricing', 'Footers', 'Banners', 'Miscellaneous'],
        layoutProperties: ['body', 'type', 'classes', 'url', 'text', 'children', 'inputType', 'theme', 'element',
            'resourceType', 'resource', 'resourceName', 'view', 'field', 'isGradientColor', 'animation',
            'trigger', 'options', 'play', 'direction', 'duration', 'orientation', 'font', 'id'],
        containerOptions: [
            'Single row',
            'Single column',
            'Two columns',
            'Three columns',
            'Four columns'
        ],
        componentTypesV2: [
            'Label', 'Header', 'Button', 'Icon', 'Link', 'Image', 'Text', 'Row Container',
            'Column Container' , 'Marquee Container'
        ],
    },
    utils: {},
    managers: {
        app: null,
        permission: null,
        state: null
    }
}

export default webase